<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="1000px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    append-to-body
    destroy-on-close
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :height="height"
      :goodsMarker="goodsMarker"
      @radio-change="(row) => (selectedRow = row)"
    />

    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        :disabled="!selectedRow"
        @click="confirm()"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '选择订单产品' },
    height: { type: Number, default: 500 },
    goodsMarker: { type: String, default: '' },
  },
  data() {
    return { selectedRow: null }
  },
  methods: {
    confirm() {
      if (!this.selectedRow) return
      this.$emit('confirm', this.selectedRow)
      this.close()
    },
    close() {
      this.selectedRow = null
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
